{
    "Accessibility menu": "Menu ng Accessibility",
    "Close": "Isara",
    "Content adjustments": "Ayusin ang Nilalaman",
    "Navigation adjustments": "Ayusin ang Pag-navigate",
    "Text Align": "Text Align",
    "Align Left": "I-align sa Kaliwa",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "I-adjust ang Laki ng Font",
    "Highlight Title": "I-highlight ang Pamagat",
    "Highlight Links": "I-highlight ang mga Link",
    "Readable Font": "Madaling Basahing Font",
    "Colour adjustments": "Ayusin ang Kulay",
    "Dark Contrast": "Madilim na Pagkakaiba",
    "Light Contrast": "Maliwanag na Pagkakaiba",
    "High Contrast": "Mataas na Pagkakaiba",
    "High Saturation": "Mataas na Saturation",
    "Low Saturation": "Mababang Saturation",
    "Monochrome": "Monokrom",
    "Tools": "Mga Kasangkapan",
    "Reading Guide": "Gabay sa Pagbabasa",
    "Big Cursor": "Malaking Cursor",
    "Increase Font Size": "Palakihin ang Laki ng Font",
    "Decrease Font Size": "Bawasan ang Laki ng Font",
    "Letter Spacing": "Espasyo ng mga Titik",
    "Line Height": "Taas ng Linya",
    "Font Weight": "Bigat ng Font",
    "Dyslexia Font": "Font para sa Dyslexia",
    "Language": "Wika",
    "Accessibility widget": "Buksan ang Menu ng Accessibility",
    "Accessibility Profiles": "Mga Profile ng Accessibility",
    "Cognitive Disability": "Kapansanan sa Kognitibo",
    "Seizure Safe": "Ligtas sa Seizure",
    "Accessibility statement": "Pahayag ng Accessibility",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Itigil ang Mga Animasyon",
    "Animation paused": "Naka-pause ang animation",
    "Reset all settings": "I-reset ang mga setting",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
